import BrandingConfigForm from './BrandingConfigForm'

const ExpandedRow = (props) => (
  <BrandingConfigForm
    setBookableParts={props.setBookableParts}
    record={props.record}
    setConfigState={props.setConfigState}
    configState={props.configState}
    setStatus={props.setStatus}
    status={props.status}
    setCurrentFormValues={props.setCurrentFormValues}
  />
)

export default ExpandedRow
